import moment from "moment";

export const ShortcutOption = {
  date: [
    {
      name: 'Last 7 Days',
      type: 'last7Days',
      timeType: 'date',
      nameCN: '最近7天',
      value: [moment().subtract(6, 'day'), moment()],
      duration: () => [moment().subtract(6, 'day')?.format("YYYY-MM-DD"), moment()?.format("YYYY-MM-DD")],
      onClick: () => {
        return [moment().subtract(6, 'day'), moment()];
      }
    },
    {
      name: 'Last 30 Days',
      nameCN: '最近30天',
      type: 'last30Days',
      timeType: 'date',
      value: [moment().subtract(29, 'day'), moment()],
      duration: () => [moment().subtract(29, 'day')?.format("YYYY-MM-DD"), moment()?.format("YYYY-MM-DD")],
      onClick: () => {
        return [moment().subtract(29, 'day'), moment()];
      }
    },
    {
      name: 'Last 90 Days',
      nameCN: '最近90天',
      type: 'last90Days',
      timeType: 'date',
      value: [moment().subtract(89, 'day'), moment()],
      duration: () => [moment().subtract(89, 'day')?.format("YYYY-MM-DD"), moment()?.format("YYYY-MM-DD")],
      onClick: () => {
        return [moment().subtract(89, 'day'), moment()];
      }
    },
    {
      name: 'Last 180 Days',
      nameCN: '最近180天',
      type: 'last180Days',
      timeType: 'date',
      value: [moment().subtract(179, 'day'), moment()],
      duration: () => [moment().subtract(179, 'day')?.format("YYYY-MM-DD"), moment()?.format("YYYY-MM-DD")],
      onClick: () => {
        return [moment().subtract(179, 'day'), moment()];
      }
    },
    {
      name: 'Last 365 Days',
      nameCN: '最近365天',
      type: 'last365Days',
      timeType: 'date',
      value: [moment().subtract(364, 'day'), moment()],
      duration: () => [moment().subtract(364, 'day')?.format("YYYY-MM-DD"), moment()?.format("YYYY-MM-DD")],
      onClick: () => {
        return [moment().subtract(364, 'day'), moment()];
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      type: 'yearToDate',
      timeType: 'date',
      value: [moment().startOf('year'), moment()],
      duration: () => [moment().startOf('year')?.format("YYYY-MM-DD"), moment()?.format("YYYY-MM-DD")],
      onClick: () => {
        return [moment().startOf('year'), moment()];
      }
    },
  ]
};